import styled from 'styled-components';
import media from 'styled-media-query';

export const Wrapper = styled.div`
  background-color: #f3f3f3;
  border-radius: 4px;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  margin: 12px 0 0 0;
  padding: 8px;

  .MuiOutlinedInput-root {
    background-color: white;

    legend {
      button {
        width: 13px;
        padding: 0;
      }
    }
  }

  .help-support {
    legend {
      button {
        width: 18px;
        padding: 0;
      }
    }
  }

  .image-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .bottom-legend-button {
    display: block;
    margin-top: 6px;
    font-size: 14px;
    color: #000000;
    text-align: right;
    max-width: 405px;
  }

  ${media.greaterThan('medium')`
    padding: 24px;
  `}
`;

export const Title = styled.h6`
  color: #000000;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  margin-bottom: 12px;

  ${media.greaterThan('medium')`
    font-size: 1.25rem;
  `}
`;
